document.documentElement.classList.add('js'); function scrollHashTargetToCenter(hash) { if (! hash) return; const id = decodeURIComponent(hash.replace(/^#/, '')); const target = id? document.getElementById(id): null; if (! target) return; target.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
} function specSheetAssetFromSku(sku) { const cleaned = String(sku || ''). toUpperCase(). replace(/_/g, '-'). replace(/FT/g, ''); const suffixes = [ '1000', '500', '250', '150', '100', '075', '75', '050', '50', '040', '40', '030', '30', '025', '25', '020', '20', '010', '10', ]; let root = cleaned; suffixes.some(function (suffix) { const marker = '-' + suffix; if (! root.endsWith(marker)) return false; root = root.slice(0, -marker.length); return true; }); return root? root + '.pdf': '';
} function updateSpecSheetDownload(sku) { const link = document.querySelector('[data-spec-sheet-link]'); if (! link ||! sku) return; const asset = specSheetAssetFromSku(sku); if (! asset) return; const base = link.dataset.assetBase || ''; link.href = base + asset; link.setAttribute('download', asset);
} function escapeHtml(value) { return String(value || ''). replace(/[&<>"']/g, function (char) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]; });
} function amazonReviewGroupKeyForSection(section) { const productType = (section.dataset.productType || ''). toLowerCase(); const handle = (section.dataset.productHandle || ''). toLowerCase(); const title = (section.dataset.productTitle || ''). toLowerCase(); const variantTitle = (section.dataset.currentVariantTitle || ''). toLowerCase(); const color = (section.dataset.currentColor || ''). toLowerCase(); const combined = [productType, handle, title, variantTitle]. join(' '); if (combined.indexOf('tracer')!== -1) { if (['blue', 'green', 'red', 'yellow']. indexOf(color)!== -1) return 'tracer-' + color; const matchedColor = ['blue', 'green', 'red', 'yellow']. find(function (colorName) { return combined.indexOf(colorName)!== -1; }); return matchedColor? 'tracer-' + matchedColor: ''; } if (combined.indexOf('thermostat')!== -1 || combined.indexOf('hvac')!== -1) { return 'thermostat-control-wire'; } if (combined.indexOf('led')!== -1 || combined.indexOf('dimmer')!== -1 || combined.indexOf('lutron')!== -1) { return 'led-dimmer-control-cable'; } if (combined.indexOf('access control')!== -1 || combined.indexOf('composite')!== -1) { return 'access-control-composite-cable'; } return '';
} function amazonReviewAssetSrc(assetUrl, src) { if (! src) return ''; if (/^https?:\/\//. test(src)) return src; const base = String(assetUrl || ''). split('amazon-review-content.json')[0] || ''; return base + src;
} function amazonReviewStars(rating) { const match = String(rating || ''). match(/\d+(?:\.\d+)?/); const count = match? Math.round(Number(match[0])): 5; return '★★★★★'. slice(0, Math.max(0, Math.min(5, count)));
} function renderAmazonReviewSection(section, data) { const list = section.querySelector('[data-amazon-review-list]'); const note = section.querySelector('[data-amazon-review-note]'); if (! list) return; const key = amazonReviewGroupKeyForSection(section); const group = data && data.groups? data.groups[key]: null; const reviews = group && Array.isArray(group.reviews)? group.reviews: []; if (! reviews.length) { list.innerHTML = '<div class="review-empty vs-card">No verified first-party Amazon reviews are available for the current SKU.This page does not mix reviews from other categories or competitors.</div>'; if (note) note.textContent = 'Reviews are matched by SKU, product category, and color rules.If no verified review is matched, this section stays empty to avoid mismatched content.'; return; } if (note) { note.textContent = (group.rule || 'Reviews are matched by SKU, product category, and color rules.') + ' Displayed reviews come from readable VOLTIC STONE Amazon product-page snapshots.Competitor reviews are not used.'; } list.innerHTML = reviews.map(function (review) { const meta = [review.author, review.date, review.variation]. filter(Boolean). map(escapeHtml). join(' · '); const images = (review.images || []). map(function (src) { return '<img src="' + escapeHtml(amazonReviewAssetSrc(section.dataset.reviewAssetUrl, src)) + '" alt="' + escapeHtml(review.title || 'Amazon review image') + '" loading="lazy">'; }). join(''); const imageBlock = images? '<div class="product-review-card__images">' + images + '</div>': ''; return '<article class="product-review-card vs-card"><div class="product-review-card__top"><span class="stars">' + escapeHtml(amazonReviewStars(review.rating)) + '</span><span>' + escapeHtml(review.rating || 'Amazon review') + '</span></div><h3>' + escapeHtml(review.title || 'Customer review') + '</h3><p class="product-review-card__meta">' + meta + '</p><p>' + escapeHtml(review.text || '') + '</p>' + imageBlock + '</article>'; }). join('');
} function loadAmazonReviewSections() { document.querySelectorAll('[data-amazon-review-section]'). forEach(function (section) { const assetUrl = section.dataset.reviewAssetUrl; if (! assetUrl) return; fetch(assetUrl). then(function (response) { if (! response.ok) throw new Error('Review asset unavailable'); return response.json(); }). then(function (data) { renderAmazonReviewSection(section, data); }). catch(function () { const list = section.querySelector('[data-amazon-review-list]'); if (list) { list.innerHTML = '<div class="review-empty vs-card">Review content is temporarily unavailable.Please confirm amazon-review-content.json is uploaded as a theme asset.</div>'; } }); });
} window.addEventListener('load', function () { if (! window.location.hash) return; window.setTimeout(function () { scrollHashTargetToCenter(window.location.hash); }, 80);
}); document.addEventListener('click', function (event) { const link = event.target.closest('a[href*="#"]'); if (! link) return; const url = new URL(link.getAttribute('href'), window.location.href); if (url.origin!== window.location.origin || url.pathname!== window.location.pathname ||! url.hash) return; event.preventDefault(); window.history.pushState(null, '', url.hash); scrollHashTargetToCenter(url.hash);
}); document.addEventListener('click', function (event) { const trigger = event.target.closest('[data-mobile-menu-toggle]'); if (! trigger) return; const nav = document.querySelector('[data-mobile-menu]'); if (! nav) return; const expanded = trigger.getAttribute('aria-expanded') === 'true'; trigger.setAttribute('aria-expanded', String(! expanded)); nav.hidden = expanded;
}); document.addEventListener('change', function (event) { const select = event.target.closest('[data-variant-select]'); if (! select) return; const selectedOption = select.options[select.selectedIndex]; const form = select.closest('form'); const priceTarget = document.querySelector('[data-product-price]'); const skuTarget = document.querySelector('[data-product-sku]'); const variantLabelTarget = document.querySelector('[data-selected-variant-label]'); const addToCartButton = form? form.querySelector('[data-add-to-cart-button]'): null; if (form) { const idInput = form.querySelector('input[name="id"]'); if (idInput) idInput.value = select.value; } if (priceTarget && selectedOption.dataset.price) { priceTarget.textContent = selectedOption.dataset.price; } if (skuTarget && selectedOption.dataset.sku) { skuTarget.textContent = selectedOption.dataset.sku; updateSpecSheetDownload(selectedOption.dataset.sku); } if (variantLabelTarget && selectedOption.dataset.title) { variantLabelTarget.textContent = selectedOption.dataset.title; } if (addToCartButton) { const available = selectedOption.dataset.available === 'true'; addToCartButton.disabled =! available; addToCartButton.textContent = available? addToCartButton.dataset.addLabel: addToCartButton.dataset.soldOutLabel; }
}); document.addEventListener('change', function (event) { const input = event.target.closest('[data-variant-option]'); if (! input) return; const form = input.closest('form'); const picker = input.closest('[data-variant-picker]'); const select = form? form.querySelector('[data-variant-select]'): null; if (! form ||! picker ||! select) return; const selectedValues = []; picker.querySelectorAll('[data-variant-option]:checked'). forEach(function (checkedInput) { selectedValues[Number(checkedInput.dataset.optionIndex)] = checkedInput.value; }); const matchedOption = Array.from(select.options). find(function (option) { const optionValues = (option.dataset.options || ''). split('||'); return optionValues.every(function (value, index) { return value === selectedValues[index]; }); }); if (! matchedOption) return; picker.querySelectorAll('.variant-pill'). forEach(function (pill) { const pillInput = pill.querySelector('[data-variant-option]'); pill.classList.toggle('is-selected', Boolean(pillInput && pillInput.checked)); }); select.value = matchedOption.value; select.dispatchEvent(new Event('change', { bubbles: true })); if (matchedOption.dataset.url) { const nextUrl = new URL(matchedOption.dataset.url, window.location.origin); if (nextUrl.href!== window.location.href) { window.location.href = nextUrl.href; } }
}); function setProductCatalogView(button, mode) { const section = button.closest('section'); const catalog = section? section.querySelector('[data-product-catalog]'): document.querySelector('[data-product-catalog]'); if (! catalog) return; catalog.dataset.view = mode; try { window.localStorage.setItem('vsProductViewMode', mode); } catch (error) { /* Ignore storage restrictions in private browsing or embedded preview. */ } const toggleScope = section || document; toggleScope.querySelectorAll('[data-product-view]'). forEach(function (toggle) { const active = toggle === button; toggle.classList.toggle('is-active', active); toggle.setAttribute('aria-pressed', String(active)); });
} document.addEventListener('click', function (event) { const button = event.target.closest('[data-product-view]'); if (! button) return; event.preventDefault(); setProductCatalogView(button, button.dataset.productView || 'grid');
}); document.addEventListener('DOMContentLoaded', function () { loadAmazonReviewSections(); const skuTarget = document.querySelector('[data-product-sku]'); if (skuTarget) updateSpecSheetDownload(skuTarget.textContent); let savedMode = 'grid'; try { savedMode = window.localStorage.getItem('vsProductViewMode') || 'grid'; } catch (error) { savedMode = 'grid'; } if (savedMode!== 'grid' && savedMode!== 'list') return; document.querySelectorAll('[data-product-catalog]'). forEach(function (catalog) { const section = catalog.closest('section'); catalog.dataset.view = savedMode; if (! section) return; section.querySelectorAll('[data-product-view]'). forEach(function (toggle) { const active = toggle.dataset.productView === savedMode; toggle.classList.toggle('is-active', active); toggle.setAttribute('aria-pressed', String(active)); }); });
}); document.addEventListener('click', function (event) { const thumb = event.target.closest('[data-product-gallery-thumb]'); if (! thumb) return; const gallery = thumb.closest('[data-product-gallery]'); const target = gallery? gallery.querySelector('[data-product-gallery-main], .product-gallery__main img'): null; const nextSrc = thumb.dataset.productGalleryThumb; const nextAlt = thumb.dataset.productGalleryAlt || ''; if (! target ||! nextSrc) return; target.removeAttribute('srcset'); target.removeAttribute('sizes'); target.src = nextSrc; target.alt = nextAlt; gallery.querySelectorAll('[data-product-gallery-thumb]'). forEach(function (button) { const active = button === thumb; button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', String(active)); });
}); function getExpandableCards(group) { return Array.from(group.children).filter(function (card) { return card.matches('.solution-diagram__node, .solution-logic-card, .solution-detail-card, .solution-guide__visual-card, .content-card, .guide-card, .support-card, .system-card, .rich-card'); });
} function cardNeedsExpansion(card) { const textNodes = Array.from(card.querySelectorAll('p, small, figcaption span')); return textNodes.some(function (node) { return node.scrollHeight > node.clientHeight + 3; });
} function markExpandableRows() { const groups = document.querySelectorAll('.solution-diagram__steps, .solution-logic-grid, .solution-detail__grid, .solution-guide__visual-grid, .content-card-grid, .support-grid, .rich-case__grid'); groups.forEach(function (group, groupIndex) { const cards = getExpandableCards(group); const rows = new Map(); cards.forEach(function (card) { card.classList.remove('is-row-expanded'); const top = Math.round(card.offsetTop / 8) * 8; const rowKey = String(groupIndex) + '-' + String(top); card.dataset.expandRow = rowKey; if (! rows.has(rowKey)) rows.set(rowKey, []); rows.get(rowKey).push(card); }); cards.forEach(function (card) { const existing = card.querySelector(':scope > .card-expand-toggle'); if (existing) existing.remove(); if (! cardNeedsExpansion(card)) return; card.classList.add('expandable-card'); const button = document.createElement('button'); button.className = 'card-expand-toggle'; button.type = 'button'; button.setAttribute('aria-expanded', 'false'); button.setAttribute('aria-label', 'Expand card'); button.addEventListener('click', function (event) { event.preventDefault(); event.stopPropagation(); const rowCards = rows.get(card.dataset.expandRow) || [card]; const shouldExpand = ! card.classList.contains('is-row-expanded'); rowCards.forEach(function (rowCard) { rowCard.classList.toggle('is-row-expanded', shouldExpand); const rowButton = rowCard.querySelector(':scope > .card-expand-toggle'); if (rowButton) { rowButton.setAttribute('aria-expanded', String(shouldExpand)); rowButton.setAttribute('aria-label', shouldExpand ? 'Collapse card' : 'Expand card'); } }); }); card.appendChild(button); }); });
} function scheduleExpandableRows() { window.setTimeout(markExpandableRows, 80);
} window.addEventListener('load', scheduleExpandableRows);
window.addEventListener('resize', function () { window.clearTimeout(window.__vsExpandableTimer); window.__vsExpandableTimer = window.setTimeout(markExpandableRows, 160);
});

function normalizeProductFilterValues(value) {
  return String(value || '').toLowerCase().split(/\s+/).filter(Boolean);
}

function productSortRank(value, order) {
  const normalized = String(value || '').toLowerCase();
  const index = order.indexOf(normalized);
  return index === -1 ? order.length : index;
}

function productSortFirstValue(card, dataKey) {
  const values = normalizeProductFilterValues(card.dataset[dataKey]);
  return values.length ? values[0] : '';
}

function productSortNumber(card, dataKey) {
  const values = normalizeProductFilterValues(card.dataset[dataKey]);
  const numbers = values.map(function (value) {
    const parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : 9999;
  }).filter(function (value) {
    return value !== 9999;
  });
  return numbers.length ? Math.min.apply(Math, numbers) : 9999;
}

function productSortKey(card) {
  const familyOrder = [
    'thermostat-control-wire',
    'led-dimmer-control-cable',
    'tracer-wire',
    'security-sound-and-alarm-cable',
    'fire-alarm-cable',
    'sprinkler-wire',
    'dog-fence-wire',
    'access-control-composite-cable',
    'general'
  ];
  const colorOrder = ['white', 'brown', 'black', 'blue', 'green', 'red', 'yellow', 'orange', 'purple', 'composite'];
  const ratingOrder = ['cmp', 'cl3p', 'fplp', 'cmr', 'cl3r', 'fplr', 'pe'];
  const shieldOrder = ['unshielded', 'shielded'];
  return [
    productSortRank(card.dataset.filterFamily, familyOrder),
    productSortRank(productSortFirstValue(card, 'filterColor'), colorOrder),
    productSortNumber(card, 'filterGauge'),
    productSortNumber(card, 'filterConductor'),
    productSortRank(productSortFirstValue(card, 'filterRating'), ratingOrder),
    productSortRank(productSortFirstValue(card, 'filterShield'), shieldOrder),
    String(card.textContent || '').trim().toLowerCase()
  ];
}

function compareProductSortCards(a, b) {
  const left = productSortKey(a);
  const right = productSortKey(b);
  for (let index = 0; index < left.length; index += 1) {
    if (left[index] < right[index]) return -1;
    if (left[index] > right[index]) return 1;
  }
  return 0;
}

function sortProductCatalogCards(root) {
  const scope = root || document;
  scope.querySelectorAll('.product-flat-list, .product-grid').forEach(function (list) {
    const cards = Array.from(list.children).filter(function (child) {
      return child.matches('[data-product-filter-card]');
    });
    if (cards.length < 2) return;
    cards.sort(compareProductSortCards).forEach(function (card) {
      list.appendChild(card);
    });
  });
}

function productFilterAllowedGroups(family) {
  const normalized = String(family || 'all').toLowerCase();
  const groups = {
    products: ['gauge', 'conductor', 'color', 'rating'],
    all: ['gauge', 'conductor', 'color', 'rating'],
    'all-products': ['gauge', 'conductor', 'color', 'rating'],
    'tracer-wire': ['color'],
    'thermostat-control-wire': ['gauge', 'conductor', 'color', 'rating'],
    'sprinkler-wire': ['gauge'],
    'led-dimmer-control-cable': ['gauge', 'conductor', 'color', 'rating'],
    'led-lighting-dimmer-control-cable': ['gauge', 'conductor', 'color', 'rating'],
    'fire-alarm-cable': ['gauge', 'conductor', 'color', 'rating'],
    'fire-alarm-cables': ['gauge', 'conductor', 'color', 'rating'],
    'security-sound-alarm-cable': ['gauge', 'conductor', 'color', 'rating'],
    'security-sound-and-alarm-cable': ['gauge', 'conductor', 'color', 'rating'],
    'access-control-composite-cable': ['gauge', 'conductor', 'color', 'rating'],
    'dog-fence-wire': ['gauge', 'color']
  };
  return groups[normalized] || groups.all;
}

function productFilterDataKey(groupName) {
  const key = String(groupName || '');
  return 'filter' + key.charAt(0).toUpperCase() + key.slice(1);
}

function productFilterCardMatches(card, activeFilters) {
  return Object.keys(activeFilters).every(function (groupName) {
    const cardValues = normalizeProductFilterValues(card.dataset[productFilterDataKey(groupName)]);
    if (! cardValues.length) return false;
    return activeFilters[groupName].some(function (selectedValue) {
      return cardValues.indexOf(selectedValue) !== -1;
    });
  });
}

function setupProductFilters(scope) {
  const cards = Array.from(scope.querySelectorAll('[data-product-filter-card]'));
  const panel = scope.querySelector('[data-product-filter-panel]');
  if (! panel) return;

  const allowedGroups = productFilterAllowedGroups(scope.dataset.productFilterFamily);
  const countTarget = scope.querySelector('[data-product-filter-count]');
  const emptyTarget = scope.querySelector('[data-product-filter-empty]');
  const clearButton = scope.querySelector('[data-product-filter-clear]');
  const groupElements = Array.from(scope.querySelectorAll('[data-filter-group]')).filter(function (element) {
    return element.matches('fieldset');
  });
  const filterFamily = scope.dataset.productFilterFamily || 'all';

  function setFilterGroupCollapsed(groupElement, collapsed) {
    const sectionToggle = groupElement.querySelector('[data-filter-section-toggle]');
    const sectionBody = groupElement.querySelector('[data-filter-section-body]');
    const sectionTitle = sectionToggle ? String(sectionToggle.textContent || '').trim() : 'filter group';
    groupElement.classList.toggle('is-section-collapsed', collapsed);
    if (sectionBody) sectionBody.hidden = collapsed;
    if (sectionToggle) {
      sectionToggle.setAttribute('aria-expanded', String(! collapsed));
      sectionToggle.setAttribute('aria-label', (collapsed ? 'Expand ' : 'Collapse ') + sectionTitle);
    }
  }

  groupElements.forEach(function (groupElement) {
    const groupName = groupElement.dataset.filterGroup;
    const groupAllowed = allowedGroups.indexOf(groupName) !== -1;
    const valuesInCards = new Set();

    cards.forEach(function (card) {
      normalizeProductFilterValues(card.dataset[productFilterDataKey(groupName)]).forEach(function (value) {
        valuesInCards.add(value);
      });
    });

    groupElement.hidden = ! groupAllowed || (cards.length > 0 && valuesInCards.size === 0);
    groupElement.classList.toggle('is-hidden', groupElement.hidden);

    groupElement.querySelectorAll('[data-filter-option]').forEach(function (option) {
      const optionValue = String(option.dataset.filterValue || '').toLowerCase();
      const shouldShow = groupAllowed && (cards.length === 0 || valuesInCards.has(optionValue));
      option.classList.toggle('is-hidden', ! shouldShow);
      const input = option.querySelector('[data-filter-input]');
      if (input) {
        input.disabled = ! shouldShow;
        if (! shouldShow) input.checked = false;
      }
    });

    const sectionToggle = groupElement.querySelector('[data-filter-section-toggle]');
    const sectionStorageKey = 'vsProductFilterSection:' + filterFamily + ':' + groupName;
    if (sectionToggle) {
      let savedCollapsed = false;
      try {
        savedCollapsed = window.localStorage.getItem(sectionStorageKey) === '1';
      } catch (error) {
        savedCollapsed = false;
      }
      setFilterGroupCollapsed(groupElement, savedCollapsed);
      sectionToggle.addEventListener('click', function () {
        const collapsed = ! groupElement.classList.contains('is-section-collapsed');
        setFilterGroupCollapsed(groupElement, collapsed);
        try {
          window.localStorage.setItem(sectionStorageKey, collapsed ? '1' : '0');
        } catch (error) {
          /* Keep the UI usable when storage is unavailable. */
        }
      });
    }
  });

  function applyFilters() {
    const activeFilters = {};
    scope.querySelectorAll('[data-filter-input]:checked').forEach(function (input) {
      const groupName = input.dataset.filterGroup;
      if (! activeFilters[groupName]) activeFilters[groupName] = [];
      activeFilters[groupName].push(String(input.value || '').toLowerCase());
    });

    let visibleCount = 0;
    cards.forEach(function (card) {
      const visible = productFilterCardMatches(card, activeFilters);
      card.hidden = ! visible;
      if (visible) visibleCount += 1;
    });

    scope.querySelectorAll('.product-catalog-group').forEach(function (group) {
      const hasVisibleCard = Boolean(group.querySelector('[data-product-filter-card]:not([hidden])'));
      group.classList.toggle('is-filter-empty', ! hasVisibleCard);
    });

    scope.querySelectorAll('.product-flat-list, .product-grid').forEach(function (list) {
      const hasVisibleCard = Boolean(list.querySelector('[data-product-filter-card]:not([hidden])'));
      list.classList.toggle('is-filter-empty', ! hasVisibleCard);
    });

    if (emptyTarget) {
      emptyTarget.hidden = visibleCount > 0;
    }

    if (countTarget) {
      const activeCount = Object.keys(activeFilters).reduce(function (total, groupName) {
        return total + activeFilters[groupName].length;
      }, 0);
      countTarget.textContent = activeCount > 0
        ? 'Showing ' + visibleCount + ' matching products'
        : 'Showing all ' + visibleCount + ' products';
    }
  }

  scope.querySelectorAll('[data-filter-input]').forEach(function (input) {
    input.addEventListener('change', applyFilters);
  });

  if (clearButton) {
    clearButton.addEventListener('click', function () {
      scope.querySelectorAll('[data-filter-input]').forEach(function (input) {
        input.checked = false;
      });
      applyFilters();
    });
  }

  applyFilters();
}

function initProductFilters() {
  sortProductCatalogCards();
  document.querySelectorAll('[data-product-filter-scope]').forEach(setupProductFilters);
}

document.addEventListener('DOMContentLoaded', initProductFilters);

function normalizeBrandTextValue(value) {
  return String(value || '').replace(/\bvoltic\s*stone\b/gi, 'VOLTIC STONE');
}

function normalizeBrandTextNodes(root) {
  const skippedTags = { SCRIPT: true, STYLE: true, NOSCRIPT: true, TEXTAREA: true };

  function walk(node) {
    if (! node) return;
    if (node.nodeType === 3) {
      const nextValue = normalizeBrandTextValue(node.nodeValue);
      if (nextValue !== node.nodeValue) node.nodeValue = nextValue;
      return;
    }
    if (node.nodeType !== 1 || skippedTags[node.tagName]) return;
    Array.from(node.childNodes).forEach(walk);
  }

  walk(root || document.body);
}

function normalizeVisibleBrandCopy() {
  document.title = normalizeBrandTextValue(document.title);
  normalizeBrandTextNodes(document.body);
}

document.addEventListener('DOMContentLoaded', normalizeVisibleBrandCopy);
window.addEventListener('load', normalizeVisibleBrandCopy);

function syncVariantPickerState() {
  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    const form = select.closest('form');
    const picker = form ? form.querySelector('[data-variant-picker]') : null;
    if (! picker) return;
    const selectedOption = select.options[select.selectedIndex];
    const selectedValues = selectedOption ? (selectedOption.dataset.options || '').split('||') : [];
    picker.querySelectorAll('[data-variant-option]').forEach(function (input) {
      const optionIndex = Number(input.dataset.optionIndex);
      const isActive = selectedValues[optionIndex] === input.value;
      input.checked = isActive;
      const pill = input.closest('.variant-pill');
      if (pill) pill.classList.toggle('is-selected', isActive);
    });
  });
}

function normalizeBuyNowButtons() {
  document.querySelectorAll('.shopify-payment-button__button').forEach(function (button) {
    if (/buy\s+it\s+now/i.test(button.textContent || '')) {
      button.textContent = 'Buy Now';
    }
  });
}

function normalizeProductPurchaseUi() {
  syncVariantPickerState();
  normalizeBuyNowButtons();
}

document.addEventListener('DOMContentLoaded', normalizeProductPurchaseUi);
window.addEventListener('load', normalizeProductPurchaseUi);
document.addEventListener('change', function (event) {
  if (event.target.closest('[data-variant-select]') || event.target.closest('[data-variant-option]')) {
    window.setTimeout(syncVariantPickerState, 0);
  }
});

if (window.MutationObserver) {
  const purchaseObserver = new MutationObserver(function () {
    normalizeBuyNowButtons();
  });
  document.addEventListener('DOMContentLoaded', function () {
    if (document.body) {
      purchaseObserver.observe(document.body, { childList: true, subtree: true });
    }
  });
}
